import 'core-js';
import 'core-js/stable';
import 'regenerator-runtime/runtime';

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import ReactDOM from 'react-dom';
import App from '@/App';
import * as serviceWorker from '@/serviceWorker';

import '@/utils/axios.conf';
import { Provider } from 'react-redux';
import store from '@/store';

import '@/tailwind.scss';
// eslint-disable-next-line import/no-webpack-loader-syntax
import '!style-loader!css-loader!sass-loader!../src/style/index.scss';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
